import 'core-js/features/promise'
import 'core-js/features/array/find'
import 'core-js/features/object/assign'
import tippy from 'tippy.js'

const toggleButtons = Array.prototype.slice.call(document.querySelectorAll('[data-inline-panel-toggle-button]'))
const infoButtons = Array.prototype.slice.call(document.querySelectorAll('[data-inline-panel-info-button]'))
const panels = document.querySelectorAll('[data-inline-panel-content]')

Array.prototype.forEach.call(toggleButtons, (link, index) => {
  link.addEventListener('click', () => {
    toggleInfoPanel(panels[index], infoButtons[index])
  })

  infoButtons[index].addEventListener('click', () => {
    toggleInfoPanel(panels[index], infoButtons[index])
  })
})

function toggleInfoPanel(panel, infoButton) {
  panel.classList.toggle('is-visible')
  infoButton.classList.toggle('inline-info-panel__info-button--is-highlighted')
}

tippy('[data-tippy-content]', {
  trigger: 'mouseenter focus click',
  placement: 'bottom',
  theme: 'light',
})
